import Api from './api';

const BASE = '/ai-suggestion';

export const generateSuggestions = async (payload) => {
  try {
    const result = await Api.post(`${BASE}/generate`, payload);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false, error: err.response?.data?.errors?.[0] || err.response?.data?.message };
  }
};

export const recordOutcome = async (payload) => {
  try {
    const result = await Api.post(`${BASE}/outcome`, payload);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false, error: err.response?.data?.errors?.[0] || err.response?.data?.message };
  }
};

export const invalidateContext = async (payload) => {
  try {
    const result = await Api.post(`${BASE}/invalidate-context`, payload);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false, error: err.response?.data?.errors?.[0] || err.response?.data?.message };
  }
};

export const getAvailability = async () => {
  try {
    const result = await Api.get(`${BASE}/availability`);
    return { success: true, data: result.data.data };
  } catch (err) {
    return { success: false, error: err.response?.data?.errors?.[0] || err.response?.data?.message };
  }
};
